const Template = `<div :class="infoClass">
	<left-menu :tubes="tubesComputed" @line-click="tubeClick"></left-menu>
	<div id="mapid"></div>
	<info-window v-if="selectedTube" :selected="selectedTube"></info-window>
</div>
`

export { Template }


// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/template.js